export const contribution = {
  '[Dearplants] Plity': [
    'Led product planning and project management.',
    'Independently developed the Android app and contributed to iOS development.'
  ]
  ,
  'Catty — Knowledge-Eating Cat': [
    'Independently planned, designed, and developed the product as a side project.'
  ],
  'Grow Up': [
    'Led product planning and project management; developed the cross-platform app in Flutter.',
  ],
  '[Ulimbridge] Psychology-based dating app': [
    'Independently developed the Android app.'
  ],
  '[ARTWA] Admin page': [
    'Independently developed the web app.'
  ],
  'UHA — One-stop childcare service': [
    'Contributed to product planning, UI/UX design, and React Native app development.'
  ],
  '[Kai-i Company] Lawlogging': [
    'Contributed to product planning and UI/UX design; independently developed the web frontend.'
  ],
  '[HanwooLab] Hair designer app': [
    'Independently developed the admin website and hybrid mobile app.'
  ],
}
